// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  SvgIcon,
  Warning
} from '../'

import {
  MessageList
} from './MessageList'

const QUERY_MESSAGE = gql`
  query($messageId: ID!) {
    whatsappmessage(id: $messageId) {
      id
      direction
      fromIdentity {
        id
        waId
      }
      fromWaId
      toIdentity {
        id
        waId
      }
      toWaId
    }
  }
`

const QUERY_MESSAGES_BY_MSISDN = gql`
  query($msisdn: String!) {
    whatsappmessages(search: $msisdn, orderBy: "created_at") {
      totalCount
      edges {
        node {
          id
          body
          direction
          messageType
          status
          createdAt
          fromIdentity {
            id
            fullName
          }
          fromWaId
          toIdentity {
            id
            fullName
          }
          toWaId
        }
      }
    }
  }
`

class WhatsAppRelatedMessagesList extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    initialMessageId: PropTypes.string.isRequired,
    currentMessageId: PropTypes.string.isRequired,
    changeMessageId: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    title: 'Related messages',
    className: ''
  }

  scrollIntoView = (id, refs, defaultScrollBehaviour = false) => {
    if (refs.hasOwnProperty(id)) {
      refs[id].current.scrollIntoView({
        behavior: defaultScrollBehaviour ? 'auto' : 'smooth',
        block: 'center',
      })
    }
  }

  render() {
    const { title, initialMessageId, currentMessageId, changeMessageId, className } = this.props

    return (
      <div className={className} style={{ height: '86vh' }}>
        <div className='u-font-size-large slds-p-top_small slds-p-bottom_small slds-border_bottom slds-align_absolute-center'>
          {title}
        </div>
        <div className='slds-scrollable section-details' style={{ height: '76vh' }}>
          <Query
            query={QUERY_MESSAGE}
            variables={{ messageId: initialMessageId }}>
            {({ loading, error, data}) => {
              if (loading) {
                return (
                  <div className='slds-is-relative' style={{ height: '80vh' }}>
                    <Spinner type='brand' size='large' />
                  </div>
                )
              }

              if (error) {
                return (
                  <Warning className='slds-m-top_medium'>
                    Failed to fetch message msisdn.
                  </Warning>
                )
              }

              if (data.whatsappmessage === null) {
                return (
                  <Warning className='slds-m-top_medium'>
                    No WhatsApp message found.
                  </Warning>
                )
              }

              return (
                <Query
                  query={QUERY_MESSAGES_BY_MSISDN}
                  variables={{
                    msisdn: data.whatsappmessage.direction === "INBOUND"
                      ? data.whatsappmessage.fromWaId
                      : data.whatsappmessage.toWaId
                    }}>
                  {({ loading, error, data }) => {
                    if (loading) {
                      return (
                        <div className='slds-is-relative' style={{ height: '80vh' }}>
                          <Spinner variant='brand' size='large' containerClassName='spinnerContainer' />
                        </div>
                      )
                    }

                    if (error) {
                      return (
                        <Warning>
                          Failed to fetch user messages.
                        </Warning>
                      )
                    }
                    const messages = data.whatsappmessages.edges.map(message => message.node)
                    const initialMessage = messages.find(message => message.id === currentMessageId)
                    const refs = messages.reduce((acc, message) => {
                      acc[message.id] = React.createRef()
                      return acc
                    }, {})

                    return (
                      <section role='log' className='chat'>
                        <div className="chat-bookend" style={{ border: 'none' }}>
                          <SvgIcon
                            variant='utility'
                            symbol='chat'
                            size='x-small'
                            colour='light'
                            className='slds-m-right_x-small'
                          />
                          <div className='slds-text-body_small slds-text-color_weak'>Start of message thread</div>
                        </div>
                        <MessageList
                          messages={messages}
                          selectedMessage={currentMessageId}
                          onMessageClick={changeMessageId}
                          scrollIntoView={this.scrollIntoView}
                          onMounted={() => this.scrollIntoView(initialMessage.id, refs, true)}
                          refs={refs}
                        />
                        <div className="chat-bookend chat-bookend_stop slds-m-top_small" style={{ border: 'none' }}>
                          <SvgIcon
                            variant='utility'
                            symbol='chat'
                            size='x-small'
                            colour='light'
                            className='slds-m-right_x-small'
                          />
                          <div className='slds-text-body_small slds-text-color_weak'>End of message thread</div>
                        </div>
                      </section>
                    )
                  }}
                </Query>
              )
            }}
          </Query>
        </div>
      </div>
    )
  }
}

export default WhatsAppRelatedMessagesList



// WEBPACK FOOTER //
// ./src/components/whatsapp-related-messages-list/index.js